module.exports = __webpack_public_path__ + "img/stand_height.72d3849b.png";